/**
 * Converts a PascalCase string to a space-separated label.
 * e.g. 'SendToIntakeQueue' → 'Send To Intake Queue'
 */
export function pascalCaseToLabel(name: string): string {
  return name.replace(/([A-Z])/g, ' $1').trim();
}

/**
 * Converts a display name to its slug form used by the backend for lookup.
 * Used as a client-side substitute for the removed `code` column on
 * priority/status snapshots. Example: "In Progress" -> "in_progress".
 * @param name Display name (e.g. snapshot.name)
 * @returns Lowercased, underscore-separated slug
 */
export function toSlug(name: string | null | undefined): string {
  return (name ?? '').trim().toLowerCase().replace(/\s+/g, '_');
}
